import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import * as employeeSelectors from "@modules/employee/selectors";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "@components";
import { MedicalHistoryForm } from "./medical-history-form";

export class AddMedicalHistoryItemModal extends React.Component {
  submitForm = () => {
    this.formRef.current.submit();
  };

  handleSubmit = form => {
    this.props.onSubmit(form);
  };

  render() {
    return (
      <Modal className="modal-small">
        <ModalHeader toggle={this.props.onDismissHandler}>{this.props.t("ADD_ITEM")}</ModalHeader>
        <ModalBody>
          <MedicalHistoryForm
            ref={this.formRef}
            data={null}
            schema={this.props.schema}
            onSubmit={this.handleSubmit}
          />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onDismissHandler}>
            {this.props.t("CANCEL")}
          </Button>
          <Button onClick={this.submitForm}>{this.props.t("SAVE_ITEM")}</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

AddMedicalHistoryItemModal.propTypes = {
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  onDismissHandler: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  schema: PropTypes.object,
  isOpen: PropTypes.bool,
  success: PropTypes.string,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  error: employeeSelectors.getError(state),
  success: employeeSelectors.getSuccessMessage(state),
  isLoading: employeeSelectors.isLoading(state),
});

export default connect(mapStateToProps)(localize()(AddMedicalHistoryItemModal));
